export default "__VITE_ASSET__B8ULqz61__"